export default {
  group: {
    rechargeBehavior: 'Etiquetas de Comportamiento de Depósito',
    withdrawBehavior: 'Etiquetas de Comportamiento de Retiro',
    betBehavior: 'Etiquetas de Comportamiento de Apuestas',
    gamePreference: 'Etiquetas de Preferencia de Juego',
    lifecycle: 'Etiquetas de Ciclo de Vida',
    userValue: 'Etiquetas de Valor del Jugador',
  },
  field: {
    tagName: 'Etiqueta',
    hitCount: 'Cantidad de Jugadores',
    hitDescription: 'Descripción de Coincidencia',
    operation: 'Operación',
    refreshDays: 'Período de Actualización',
    lastUpdateTime: 'Última Actualización',
    nextUpdateTime: 'Próxima Actualización Automática',
    refreshCycle: 'Intervalo',
    configSetting: 'Configuración de Coincidencia',
  },
  action: {
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    setting: 'Configuración',
    save: 'Guardar',
    back: 'Atrás',
    manualUpdate: 'Actualización Manual',
    updating: 'Actualizando...',
    confirm: 'Aceptar',
  },
  unit: {
    days: 'Días',
  },
  connector: {
    and: 'y ≤',
  },
  pageTitle: 'Configuración de Etiquetas Automáticas',
  settingTitle: ' Configuración',
  noAutoTags: 'Sin etiquetas automáticas',
  message: {
    statusUpdateSuccess: 'Estado actualizado exitosamente',
    statusUpdateFailed: 'Error al actualizar estado',
    saveSuccess: 'Guardado exitosamente',
    saveFailed: 'Error al guardar',
    configRequired: 'Todos los campos son requeridos, complete la configuración',
    manualUpdateSuccess: 'Actualización manual iniciada, calculando en segundo plano. Actualice después.',
    manualUpdateFailed: 'Error en actualización manual',
    groupCalculating: 'Este grupo de etiquetas se está actualizando automáticamente, intente después.',
  },
  configRule: {
    integerOnly: 'Solo enteros positivos',
    amountUnit: 'La unidad de monto es consistente con la moneda de depósito de la plataforma',
    emptyDisabled: 'Una etiqueta con umbral vacío no participa en coincidencia para esta moneda',
  },
  tag: {
    FIRST_RECHARGE: 'Jugador con Primer Depósito',
    NO_RECHARGE: 'Jugador sin Depósitos',
    RECHARGE_FREQ_LOW: 'Baja Frecuencia de Depósitos',
    RECHARGE_FREQ_MID: 'Frecuencia Media de Depósitos',
    RECHARGE_FREQ_HIGH: 'Alta Frecuencia de Depósitos',
    RECHARGE_AMT_LOW: 'Monto Bajo de Depósitos',
    RECHARGE_AMT_MID: 'Monto Medio de Depósitos',
    RECHARGE_AMT_HIGH: 'Monto Alto de Depósitos',
    NO_WITHDRAW: 'Jugador sin Retiros',
    WITHDRAW_FREQ_LOW: 'Baja Frecuencia de Retiros',
    WITHDRAW_FREQ_MID: 'Frecuencia Media de Retiros',
    WITHDRAW_FREQ_HIGH: 'Alta Frecuencia de Retiros',
    WITHDRAW_AMT_LOW: 'Monto Bajo de Retiros',
    WITHDRAW_AMT_MID: 'Monto Medio de Retiros',
    WITHDRAW_AMT_HIGH: 'Monto Alto de Retiros',
    NO_BET: 'Jugador sin Apuestas',
    BET_FREQ_LOW: 'Baja Frecuencia de Apuestas',
    BET_FREQ_MID: 'Frecuencia Media de Apuestas',
    BET_FREQ_HIGH: 'Alta Frecuencia de Apuestas',
    BET_AMT_LOW: 'Monto Bajo de Apuestas',
    BET_AMT_MID: 'Monto Medio de Apuestas',
    BET_AMT_HIGH: 'Monto Alto de Apuestas',
    PREFER_LIVE: 'Prefiere Casino en Vivo',
    PREFER_SLOT: 'Prefiere Tragamonedas',
    PREFER_SPORT: 'Prefiere Apuestas Deportivas',
    PREFER_CHESS: 'Prefiere Juegos de Mesa',
    ACTIVE_RETAINED: 'Jugador Activo Retenido',
    ACTIVE_NO_DEPOSIT: 'Jugador Activo sin Depósito',
    RETURN_NO_RECHARGE: 'Jugador Retornado sin Recarga',
    CHURN_RISK: 'Jugador en Riesgo de Inactividad',
    CHURNED: 'Jugador Inactivo',
    NET_LOSS_HIGH: 'Jugador con Alta Pérdida Neta',
    NET_LOSS_MID: 'Jugador con Pérdida Neta Media',
    NET_LOSS_LOW: 'Jugador con Baja Pérdida Neta',
    NET_WIN_HIGH: 'Jugador con Alta Ganancia Neta',
    NET_WIN_MID: 'Jugador con Ganancia Neta Media',
    NET_WIN_LOW: 'Jugador con Baja Ganancia Neta',
  },
  hitDesc: {
    FIRST_RECHARGE: 'Primer depósito = 1',
    NO_RECHARGE: 'Cantidad total de depósitos = 0',
    RECHARGE_FREQ_LOW: 'Cantidad total de depósitos ≤ X',
    RECHARGE_FREQ_MID: 'Cantidad total de depósitos ≥ X y ≤ X',
    RECHARGE_FREQ_HIGH: 'Cantidad total de depósitos ≥ X',
    RECHARGE_AMT_LOW: 'Monto total de depósitos ≤ X',
    RECHARGE_AMT_MID: 'Monto total de depósitos ≥ X y ≤ X',
    RECHARGE_AMT_HIGH: 'Monto total de depósitos ≥ X',
    NO_WITHDRAW: 'Cantidad total de retiros = 0',
    WITHDRAW_FREQ_LOW: 'Cantidad total de retiros ≤ X',
    WITHDRAW_FREQ_MID: 'Cantidad total de retiros ≥ X y ≤ X',
    WITHDRAW_FREQ_HIGH: 'Cantidad total de retiros ≥ X',
    WITHDRAW_AMT_LOW: 'Monto total de retiros ≤ X',
    WITHDRAW_AMT_MID: 'Monto total de retiros ≥ X y ≤ X',
    WITHDRAW_AMT_HIGH: 'Monto total de retiros ≥ X',
    NO_BET: 'Cantidad total de apuestas = 0',
    BET_FREQ_LOW: 'Cantidad total de apuestas ≤ X',
    BET_FREQ_MID: 'Cantidad total de apuestas ≥ X y ≤ X',
    BET_FREQ_HIGH: 'Cantidad total de apuestas ≥ X',
    BET_AMT_LOW: 'Monto total de apuestas ≤ X',
    BET_AMT_MID: 'Monto total de apuestas ≥ X y ≤ X',
    BET_AMT_HIGH: 'Monto total de apuestas ≥ X',
    PREFER_LIVE: 'Ratio de apuestas en casino en vivo ≥ 50%',
    PREFER_SLOT: 'Ratio de apuestas en tragamonedas ≥ 50%',
    PREFER_SPORT: 'Ratio de apuestas deportivas ≥ 50%',
    PREFER_CHESS: 'Ratio de apuestas en juegos de mesa ≥ 50%',
    ACTIVE_RETAINED: '≤ 7 días con apuestas y depósitos (no primer depósito)',
    ACTIVE_NO_DEPOSIT: '≤ 7 días con apuestas y sin depósitos',
    RETURN_NO_RECHARGE: '≤ 7 días con apuestas, sin depósitos, último depósito ∈ [hace 15 días, hace 30 días]',
    CHURN_RISK: '7 días consecutivos sin inicio de sesión/apuestas, tuvo depósitos en los últimos 7-15 días',
    CHURNED: '15 días consecutivos sin inicio de sesión/apuestas, tuvo depósitos hace más de 30 días',
    NET_LOSS_HIGH: 'Pérdida neta ≥ X',
    NET_LOSS_MID: 'Pérdida neta ≥ X y ≤ X',
    NET_LOSS_LOW: 'Pérdida neta ≤ X',
    NET_WIN_HIGH: 'Ganancia neta ≥ X',
    NET_WIN_MID: 'Ganancia neta ≥ X y ≤ X',
    NET_WIN_LOW: 'Ganancia neta ≤ X',
  },
  configLabel: {
    RECHARGE_FREQ_LOW: 'Cantidad total de depósitos ≤',
    RECHARGE_FREQ_MID: 'Cantidad total de depósitos ≥',
    RECHARGE_FREQ_HIGH: 'Cantidad total de depósitos ≥',
    RECHARGE_AMT_LOW: 'Monto total de depósitos ≤',
    RECHARGE_AMT_MID: 'Monto total de depósitos ≥',
    RECHARGE_AMT_HIGH: 'Monto total de depósitos ≥',
    WITHDRAW_FREQ_LOW: 'Cantidad total de retiros ≤',
    WITHDRAW_FREQ_MID: 'Cantidad total de retiros ≥',
    WITHDRAW_FREQ_HIGH: 'Cantidad total de retiros ≥',
    WITHDRAW_AMT_LOW: 'Monto total de retiros ≤',
    WITHDRAW_AMT_MID: 'Monto total de retiros ≥',
    WITHDRAW_AMT_HIGH: 'Monto total de retiros ≥',
    BET_FREQ_LOW: 'Cantidad total de apuestas ≤',
    BET_FREQ_MID: 'Cantidad total de apuestas ≥',
    BET_FREQ_HIGH: 'Cantidad total de apuestas ≥',
    BET_AMT_LOW: 'Monto total de apuestas ≤',
    BET_AMT_MID: 'Monto total de apuestas ≥',
    BET_AMT_HIGH: 'Monto total de apuestas ≥',
    NET_LOSS_HIGH: 'Pérdida neta ≥',
    NET_LOSS_MID: 'Pérdida neta ≥',
    NET_LOSS_LOW: 'Pérdida neta ≤',
    NET_WIN_HIGH: 'Ganancia neta ≥',
    NET_WIN_MID: 'Ganancia neta ≥',
    NET_WIN_LOW: 'Ganancia neta ≤',
  },
}
